import { Link } from 'react-router-dom';
import { PlusIcon, VideoIcon } from 'lucide-react';
import { PageHeader } from '../ui/PageHeader';
import { OfferTabs } from './OfferTabs';
import { Badge } from '../ui/Badge';
import { useAdmin } from '../AdminContext';
import { btnPrimary, listBox, rowLink } from '../ui/styles';
import { kuurLabel, treatmentDuration, treatmentPrice } from '../../utils/catalog';
import { treatmentCategories } from '../../data/treatments';

/** Alle behandelingen, per categorie. */
export function Treatments() {
  const {
    catalog
  } = useAdmin();
  return <div data-id="element-1001" data-mp="19wg8u8a39cfi">
      <PageHeader title="Behandelingen" description="Wat je in de salon (en online) aanbiedt. Prijs en duur verschijnen op de salonpagina en in de afsprakenlade." actions={<Link to="/be/behandelingen/nieuw" className={btnPrimary} data-id="element-1003" data-mp="1ixecgpgm7hxk">
            <PlusIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-1004" data-mp="2z7qhawudad3z" />
            Nieuwe behandeling
          </Link>} data-id="element-1002" data-mp="19wq162ilvvod" />
      <OfferTabs data-id="element-1005" data-mp="2dmzmep2punwq" />

      <div className="space-y-8" data-id="element-1006" data-mp="2dniu7cynjvx1">
        {treatmentCategories.map((cat, i) => {
        const items = catalog.treatments.filter(t => t.category === cat);
        if (!items.length) return null;
        // Categorienamen bevatten spaties en streepjes; een index is een veilig id.
        const headingId = `treatment-cat-${i}`;
        return <section key={cat} aria-labelledby={headingId} data-id="element-1007" data-mp="2shnpjwkn9a96" data-mpi={i}>
              <h2 id={headingId} className="mb-3 font-display text-[18px] text-ink" data-id="element-1008" data-mp="1uxkkytj4bwrt">
                {cat} <span className="font-sans text-[13px] text-muted" data-id="element-1009" data-mp="1zwe0erhytxum">· {items.length}</span>
              </h2>
              <ul className={listBox} data-id="element-1010" data-mp="24tnpg61g07hx">
                {items.map(t => <li key={t.slug} data-id="element-1011" data-mp="29le0yfc491ax">
                    <Link to={`/be/behandelingen/${t.slug}`} className={`${rowLink} flex-wrap gap-y-1`} data-id="element-1012" data-mp="29mgrgm5j11qb">
                      <span className="min-w-0 flex-1" data-id="element-1013" data-mp="1c3nrkr5czuok">
                        <span className="flex items-center gap-2 text-[15px] text-ink" data-id="element-1014" data-mp="1h41s7o4ms2ck">
                          <span className="truncate" data-id="element-1015" data-mp="193nf18xeh3m5">{t.name}</span>
                          {t.signature && <Badge tone="soft" data-id="element-1016" data-mp="145c0wm02o6y4">Signature</Badge>}
                          {t.online && <>
                              <VideoIcon className="h-3.5 w-3.5 shrink-0 text-muted" strokeWidth={1.75} aria-hidden="true" data-id="element-1017" data-mp="1isndmr7zpwzt" />
                              <span className="sr-only" data-id="element-1018" data-mp="1dvnez1dgzwiq">Online</span>
                            </>}
                        </span>
                        <span className="block truncate text-[13px] text-muted" data-id="element-1019" data-mp="l6zu36wmv95p">{t.tagline}</span>
                      </span>
                      <span className="text-[13px] tabular-nums text-muted" data-id="element-1020" data-mp="1051xnh3nzumy">{treatmentDuration(t)}</span>
                      <span className="text-[14px] tabular-nums text-ink sm:w-40 sm:text-right" data-id="element-1021" data-mp="v2t4ajmvqqkb">
                        {treatmentPrice(t)}
                        {t.kuur && <span className="block text-[12px] text-muted" data-id="element-1022" data-mp="26k2iorr5iser">{kuurLabel(t)}</span>}
                      </span>
                    </Link>
                  </li>)}
              </ul>
            </section>;
      })}
      </div>
    </div>;
}